import React from 'react'
import Contacts from '../Components/Contact/index'
// import Testimonialscards from '../Components/Testi/Testimonial_cards'


const Contact = () => {
  return (
    <>
    <Contacts/>
    </>
  )
}

export default Contact